import { render } from "./uk12.vue?vue&type=template&id=c5c74c5a"
import script from "./uk12.vue?vue&type=script&lang=js"
export * from "./uk12.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__